import React from 'react';
import FadeInAnimation from "../Common/FadeInAnimation";
import { Player } from '@lottiefiles/react-lottie-player';
import { useTranslations } from '../../locales/useTranslations';


const ItConsultingEigenschaften = () => {
    const { t } = useTranslations();

    return (
        <div className="features-card-section pt-70 pb-70 bg-f8fbfa">
            <div className="container">

                <div className="row">
                    <div className="col-lg-4 col-sm-12 feature-card">
                        <FadeInAnimation animateIn="fadeInUp" delay={50} animateOnce={true} style={{ "display": "flex" }}>
                            <div className="single-features-card tx-center">
                                <Player
                                    hover
                                    loop
                                    src="/images/it-consultant/individual-communication.json"
                                    style={{ height: '300px' }}
                                />
                                <h3>{t('itConsulting_features_individualCons_title')}</h3>
                                <p>{t('itConsulting_features_individualCons_description')}</p>
                            </div>
                        </FadeInAnimation>
                    </div>

                    <div className="col-lg-4 col-sm-12 feature-card">
                        <FadeInAnimation animateIn="fadeInUp" delay={100} animateOnce={true} style={{ "display": "flex" }}>
                            <div className="single-features-card tx-center">
                                <Player
                                    hover
                                    loop
                                    src="/images/it-consultant/a2.json"
                                    style={{ height: '300px' }}
                                />
                                <h3>{t('itConsulting_features_processOptimization_title')}</h3>
                                <p>{t('itConsulting_features_processOptimization_description')}</p>
                            </div>
                        </FadeInAnimation>
                    </div>

                    <div className="col-lg-4 col-sm-12 feature-card">
                        <FadeInAnimation animateIn="fadeInUp" delay={150} animateOnce={true} style={{ "display": "flex" }}>
                            <div className="single-features-card tx-center">
                                <Player
                                    hover
                                    loop
                                    src="/images/it-consultant/process-optimization.json"
                                    style={{ height: '300px' }}
                                />
                                <h3>{t('itConsulting_features_digitalTransformation_title')}</h3>
                                <p>{t('itConsulting_features_digitalTransformation_description')}</p>
                            </div>
                        </FadeInAnimation>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default ItConsultingEigenschaften;